import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Tooltip, Icon, Upload, message } from "antd";
import InputForm from "./InputForm";
import { checkFormIsValid } from '../utils/Validator';
import "./Form.css";
import axios from 'axios';
import NumberFormat from 'react-number-format';
import { vlrMoedaDigitado } from '../utils/Masker';
import { getUsuario } from "../utils/LoginManager";

const { Item: ItemForm } = Form;

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}

function beforeUpload(file) {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  if (!isJpgOrPng) {
    message.error('Você só pode enviar arquivos JPG / PNG!');
  }
  const isLt2M = file.size / 1024 / 1024 < 0.1;
  if (!isLt2M) {
    message.error('A imagem deve ter menos de 100 KB!');
  }
  return isJpgOrPng && isLt2M;
}


export default class ProdutoForm extends Component {
  state = {
    registro: {
      prod_codigo: '0',

      imgNome: '',
      imgSize: '0',
      imgData: '',
      base64: '',
      pathImagem: null,
    },
    grupoSelect: [],
    MarcasSelect: [],
    MedidasSelect: [],
    previewVisible: false,
  };

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({ usuario })
  }

  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado
      }, () => {
        this.buscaGrupo();
        this.buscaMarca();
        this.buscaMedidas();
        this.refs.prod_cod_original.focus();
      });
    }
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    const { registro } = this.state;
    registro[id] = value;

    this.setState({
      [id]: value
    });
  };

  onOK = () => {
    if ((!this.state.registro.prod_descricao) || (this.state.registro.prod_descricao === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Descrição' });
      return;
    }
    if ((!this.state.registro.prod_grupo) || (this.state.registro.prod_grupo.key === '0') || (this.state.registro.prod_grupo.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Grupo', });
      return;
    }
    if ((!this.state.registro.prod_marca) || (this.state.registro.prod_marca.key === '0') || (this.state.registro.prod_marca.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Marca', });
      return;
    }
    if ((!this.state.registro.prod_medida) || (this.state.registro.prod_medida.key === '0') || (this.state.registro.prod_medida.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Unidade de Medida', });
      return;
    }

    this.state.registro.prod_cod_original = this.state.registro.prod_cod_original ? String(this.state.registro.prod_cod_original) : '';
    this.state.registro.prod_grupo = this.state.registro.prod_grupo.key;
    this.state.registro.prod_marca = this.state.registro.prod_marca.key;
    this.state.registro.prod_medida = this.state.registro.prod_medida.key;
    this.state.registro.prod_medida2 = this.state.registro.prod_medida2 && this.state.registro.prod_medida2.key ? this.state.registro.prod_medida2.key : '';

    this.props.onSalvarClick(this.state.registro);
  };


  buscaGrupo = (value) => {
    this.setState({ grupoSelect: [] })
    const { prod_grupo } = this.state.registro;
    axios.get('/grupos/lista', {
    }).then(response => {
      const { data } = response;
      const grupoSelect = data.map(regList => {
        return {
          key: regList.grp_idf,
          label: regList.grp_descricao
        }
      });

      let grupo = prod_grupo;
      if (!prod_grupo) {
        grupo = grupoSelect[0].key;
      }

      this.setState({
        grupoSelect,
        prod_grupo: grupo,
      })

    }).catch(error => {
      console.error(error.response);
    })
  }

  buscaMarca = (value) => {
    this.setState({ marcaSelect: [] })
    const { prod_marca } = this.state.registro;

    axios.get('/marcas/lista', {
    }).then(response => {
      const { data } = response;
      const marcaSelect = data.map(regList => {
        return {
          key: regList.mar_idf,
          label: regList.mar_descricao
        }
      });

      let marca = prod_marca;
      if (!prod_marca) {
        marca = marcaSelect[0].key;
      }

      this.setState({
        marcaSelect,
        prod_marca: marca,
      })

    }).catch(error => {
      console.error(error.response);
    })
  }

  buscaMedidas = (value) => {
    this.setState({ medidaSelect: [] })
    const { prod_medida, prod_medida2 } = this.state.registro;

    axios.get('/medidas/lista', {
    }).then(response => {
      const { data } = response;
      const medidaSelect = data.map(regList => {
        return {
          key: regList.med_idf,
          label: regList.med_descricao
        }
      });

      let medida = prod_medida;
      if (!prod_medida) {
        medida = medidaSelect[0].key;
      }

      //      let medida2 = prod_medida2;
      //      if (!prod_medida2) {
      //        medida2 = medidaSelect[0].key;
      //      }

      this.setState({
        medidaSelect,
        prod_medida: medida,
        //        prod_medida2: medida2,
      })

    }).catch(error => {
      console.error(error.response);
    })
  }


  handleChange = info => {
    // console.log('handleChange: ', info);

    const isJpgOrPng = info.file.type === 'image/jpeg' || info.file.type === 'image/png';
    if (!isJpgOrPng) {
      return;
    }
    const isLt2M = info.file.size / 1024 / 1024 < 0.1;
    if (!isLt2M) {
      return;
    }

    this.setState({
      registro: {
        ...this.state.registro,
        imgNome: '',
        imgSize: '',
        imgData: '',
        pathImagem: '',
        base64: '',
      },
    });

    getBase64(info.file.originFileObj, imageUrl =>
      this.setState({
        registro: {
          ...this.state.registro,
          imgNome: info.file.name,
          imgSize: info.file.size,
          imgData: info.file.lastModifiedDate,
          pathImagem: '',
          base64: imageUrl,
        },
        loading: false,
      }),
    );
  };

  onRemoveImage = (file) => {
    const { confirm } = Modal
    return new Promise((resolve, reject) => {
      confirm({
        title: 'Deseja Excluir a Imagem?',
        onOk: () => {
          resolve(true)
          this.setState({
            registro: {
              ...this.state.registro,
              imgNome: '',
              imgSize: '',
              imgData: '',
              pathImagem: '',
              base64: '',
            },
          });
        },
        onCancel: () => {
          reject(true)
        }
      })
    })
  }


  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { grupoSelect, marcaSelect, medidaSelect, previewVisible, previewImage } = this.state;
    const { prod_codigo, prod_cod_original, prod_cod_barras, prod_descricao, prod_qtde_atual,
      prod_vlr_custo, prod_preco_tab1, prod_preco_tab2,
      prod_grupo, prod_marca, prod_medida, prod_medida2, prod_medida2_conversao, prod_peso, base64, pathImagem } = this.state.registro;

    const uploadButton = (
      <div>
        {this.state.loading ? <Icon type="loading" style={{ color: 'rgba(0,0,0,0.4)' }} /> : <Icon type="plus" style={{ color: 'rgba(0,0,0,0.4)' }} />}
        <div className="ant-upload-text">Imagem</div>
      </div>
    );

    // console.log('ProdutoForm: ', this.state);

    return (
      <Modal
        title={prod_codigo ? "Edição de Produto" : "Cadastro de Produto"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"60%"}
        style={{ top: 30 }}
      >
        <Form>
          <Row>
            <Col xs={24} sm={4} style={{ paddingRight: 20 }}>
              <span>Código</span>
              <InputForm
                id="prod_codigo"
                value={prod_codigo}
                readOnly
              />
            </Col>

            <Col xs={24} sm={4} style={{ paddingRight: 20 }}>
              <span>Cód Orig</span>
              <InputForm
                id="prod_cod_original"
                ref="prod_cod_original"
                maxLength={20}
                onChange={this.onChange}
                value={prod_cod_original}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={4} style={{ paddingRight: 20 }}>
              <span>Cód Barras</span>
              <InputForm
                id="prod_cod_barras"
                ref="prod_cod_barras"
                maxLength={20}
                onChange={this.onChange}
                value={prod_cod_barras}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={12} style={{}}>
              <span>Descrição</span>
              <InputForm
                id="prod_descricao"
                ref="prod_descricao"
                maxLength={60}
                onChange={this.onChange}
                value={prod_descricao}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Grupo</span>
              <InputForm
                type="select"
                id="prod_grupo"
                ref="prod_grupo"
                value={prod_grupo}
                placeholder="Grupo"
                onChange={this.onChange}
                data={grupoSelect}
                validator={value => Boolean(value)}
                showSearch
              />
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -20 }}>
              <span>Marca</span>
              <InputForm
                type="select"
                id="prod_marca"
                ref="prod_marca"
                value={prod_marca}
                placeholder="Marca"
                onChange={this.onChange}
                data={marcaSelect}
                validator={value => Boolean(value)}
                showSearch
              />
            </Col>

            <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Medida</span>
              <InputForm
                type="select"
                id="prod_medida"
                ref="prod_medida"
                value={prod_medida}
                placeholder="Medida"
                onChange={this.onChange}
                data={medidaSelect}
                validator={value => Boolean(value)}
                showSearch
              />
            </Col>

            <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Medida 2</span>
              <InputForm
                type="select"
                id="prod_medida2"
                ref="prod_medida2"
                value={prod_medida2}
                placeholder="Medida"
                onChange={this.onChange}
                data={medidaSelect}
                validator={value => Boolean(value)}
                showSearch
              />
            </Col>

            <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Fator Conversão</span>
              <InputForm
                type="number"
                id="prod_medida2_conversao"
                ref="prod_medida2_conversao"
                value={prod_medida2_conversao}
                onChange={this.onChange}
                decimalScale={6}
              />
            </Col>

            <Col xs={24} sm={6} style={{ marginTop: -20 }}>
              <span>Peso</span>
              <InputForm
                type="number"
                id="prod_peso"
                ref="prod_peso"
                value={prod_peso}
                onChange={this.onChange}
                decimalScale={2}
              />
            </Col>

            <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Qtde Estoque</span>
              <InputForm
                type="number"
                id="prod_qtde_atual"
                ref="prod_qtde_atual"
                value={prod_qtde_atual}
                onChange={this.onChange}
              />
            </Col>

            <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Vlr Custo</span>
              <InputForm
                type="number"
                id="prod_vlr_custo"
                ref="prod_vlr_custo"
                value={prod_vlr_custo}
                onChange={this.onChange}
              />
            </Col>

            <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Preço Tab 1</span>
              <InputForm
                type="number"
                id="prod_preco_tab1"
                ref="prod_preco_tab1"
                value={prod_preco_tab1}
                onChange={this.onChange}
              />
            </Col>

            <Col xs={24} sm={6} style={{ marginTop: -20 }}>
              <span>Preço Tab 2</span>
              <InputForm
                type="number"
                id="prod_preco_tab2"
                ref="prod_preco_tab2"
                value={prod_preco_tab2}
                onChange={this.onChange}
              />
            </Col>

            <div>
              <Tooltip title="Carregar Imagem" placement="topLeft">
                <Col xs={24} style={{ marginTop: 0 }}>
                  <Upload
                    name="avatar"
                    listType="picture-card"
                    showUploadList={false}
                    beforeUpload={beforeUpload}
                    onChange={this.handleChange}
                  >
                    {base64 || pathImagem ? <img src={base64 ? base64 : pathImagem} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                  </Upload>
                </Col>
              </Tooltip>
              {base64 || pathImagem ? (
                <Col xs={24} style={{ marginTop: -40 }}>
                  <Tooltip title="Excluir Imagem" placement="right">
                    <Button
                      type="ghost"
                      htmlType="button"
                      loading={carregando}
                      onClick={this.onRemoveImage}
                      icon="delete"
                      className="botoesModalFormExcluir"
                    ></Button>
                  </Tooltip>
                </Col>
              ) : null}
            </div>

          </Row>
          <ItemForm>
            <Row>
              <Col xs={24}>
                 <Button
                  htmlType="button"
                  loading={carregando}
                  onClick={this.onOK}
                  className="botoesModalForm"
                >
                  Salvar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="botoesModalFecharForm"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>

        <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
          <img alt="example" style={{ width: '100%' }} src={previewImage} />
        </Modal>

      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ProdutoForm.js